export default __webpack_public_path__ + "static/media/040_tunnel.av1.6a95dea2.mp4";